"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moveConversations_1 = require("./moveConversations");
var moveItems_1 = require("./moveItems");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('moveMailListRows')(function moveMailListRows(rowKeys, destinationFolderId, originalTableViewId, actionSource) {
    var originalTableView = owa_mail_list_store_1.listViewStore.tableViews.get(originalTableViewId);
    switch (originalTableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            moveConversations_1.default(rowKeys, destinationFolderId, originalTableView, actionSource);
            break;
        case 1 /* Message */:
            moveItems_1.default(rowKeys, destinationFolderId, originalTableView, actionSource);
            break;
    }
});
//# sourceMappingURL=moveMailListRows.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/moveMailListRows.js
// module id = 3819
// module chunks = 62